import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

interface CardholderNameInputProps {
    cardholderName: string;
    onSetCardholderName: (amount: string) => void;
    onSetIsCardholderNameValid: (isAmountValid: boolean) => void;
}

export const CardholderNameInput: React.FunctionComponent<CardholderNameInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const requiredCardholderNameError = 'Cardholder Name is a required field.';
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    useEffect(() => {
        props.onSetIsCardholderNameValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        const cardholderName = (event.target as HTMLInputElement).value;
        props.onSetCardholderName(cardholderName);
        validateCardholderName(cardholderName);
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateCardholderName();
    }

    const validateCardholderName = (cardholderName: string = '') => {
        cardholderName = cardholderName || props.cardholderName;
        let errorsTemp: string[] = [];
        if (cardholderName === '') {
            errorsTemp.push(requiredCardholderNameError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        setIsSubmitted(true);
        validateCardholderName();
    }

    return <div>
        <Input isValid={isValid} type='text' required={true} value={props.cardholderName} onChange={onChange}
               onKeyUp={onKeyUp} onBlur={onBlur}/>
        {isSubmitted && errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
